import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  old: 'Disconnected spreadsheets',
  new: 'One unified data model'
}, {
  old: 'Inbox-only deal tracking',
  new: 'Structured deal pipelines'
}, {
  old: "Unconfirmed 'booked' dates",
  new: 'Locked contracts & lineup'
}, {
  old: 'Hunting for riders & invoices',
  new: 'Centralized tour ops'
}];
export function ComparisonSection() {
  return <section className="py-24 bg-surface/10 border-t border-border relative overflow-hidden" data-id="element-287">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-288">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold mb-16" data-id="element-289">
          Replace the patchwork stack.
        </motion.h2>

        <div className="bg-surface/50 backdrop-blur-md border border-border rounded-xl p-8 md:p-12 text-left shadow-2xl" data-id="element-290">
          <div className="grid gap-6" data-id="element-291">
            {comparisons.map((item, index) => <div key={index} className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 p-4 rounded-lg bg-background/80 border border-border relative overflow-hidden" data-id="element-292">
                {/* Old Way */}
                <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.2
            }} className="flex items-center gap-3 text-textMuted relative" data-id="element-293">
                  <div className="relative" data-id="element-294">
                    <div className="absolute inset-0 bg-red-500/20 blur-md rounded-full" data-id="element-295"></div>
                    <X className="w-5 h-5 text-red-500 shrink-0 relative z-10" data-id="element-296" />
                  </div>
                  <span className="relative" data-id="element-297">
                    No more {item.old.toLowerCase()}
                    {/* Animated Strikethrough */}
                    <motion.div initial={{
                  scaleX: 0
                }} whileInView={{
                  scaleX: 1
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.2 + 0.4,
                  duration: 0.4,
                  ease: 'easeOut'
                }} className="absolute top-1/2 left-0 w-full h-px bg-red-500/50 origin-left" data-id="element-298" />
                  </span>
                </motion.div>

                <div className="hidden md:block w-8 h-px bg-border" data-id="element-299"></div>

                {/* New Way */}
                <motion.div initial={{
              opacity: 0,
              x: 20,
              filter: 'blur(5px)'
            }} whileInView={{
              opacity: 1,
              x: 0,
              filter: 'blur(0px)'
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.2 + 0.6,
              duration: 0.5
            }} className="flex items-center gap-3 text-textMain font-medium" data-id="element-300">
                  <div className="relative" data-id="element-301">
                    <div className="absolute inset-0 bg-primary/20 blur-md rounded-full" data-id="element-302"></div>
                    <Check className="w-5 h-5 text-primary shrink-0 relative z-10" data-id="element-303" />
                  </div>
                  <span data-id="element-304">{item.new}</span>
                </motion.div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}